var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',_vm._l((_vm.programs),function(program){return _c('v-col',{key:program.id,attrs:{"cols":"12","sm":"6","lg":"4","xl":"3"}},[_c('program-card',{attrs:{"program":program,"isBookmarked":!_vm.builder ? program.id === _vm.selectedProgramId : false},on:{"click":function($event){return _vm.$emit('programClicked', program.id)}}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }